'use strict';

angular.module('MimosaApp').controller('FwtPageController', function() {

});